<template>

  <v-autocomplete v-model="placeID"
                  label="Place"
                  :placeholder="placeholder"
                  :items="places"
                  item-text="name"
                  item-value="id"
                  :clearable="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"
                  :search-input.sync="textInput">
    <template slot="item" slot-scope="{ item }">
      <v-list-tile-content>
        <p class="item-text">
          {{ item.name }} - <b class="item-text-small">{{ item.zipCode || 'Unknown zipcode' }} - {{ item.city || 'Unknown city' }}</b>
        </p>
      </v-list-tile-content>
    </template>
  </v-autocomplete>

</template>

<script>

export default {
  name: 'PlaceSelector',
  props: ['currentPlaceID'],
  data () {
    return {
      loading: false,
      places: [],
      placeID: '',

      textInput: ''
    }
  },
  mounted () {
    if (this.currentPlaceID) {
      this.setCurrentPlace()
    }
  },
  methods: {
    handleInput (input) {
      this.loading = false
      this.textInput = input
      setTimeout(() => {
        if (input && (this.textInput === input)) {
          this.loading = true
          this.loadPlaces()
        }
      }, 400)
    },
    setCurrentPlace () {
      this.loading = true
      this.$store.dispatch('getPlace', this.currentPlaceID)
        .then(resp => {
          this.places = [resp]
          this.placeID = this.currentPlaceID
          this.loading = false
        })
        .catch(() => {
          console.error('Error loading place')
          this.loading = false
        })
    },
    loadPlaces () {
      this.$store.dispatch('searchPlaces', {
        name: this.textInput
      })
        .then(resp => {
          this.places = resp.items
          this.loading = false
        })
        .catch(() => {
          console.error('Error loading places')
          this.loading = false
        })
    },
    clear () {
      this.placeID = ''
      this.places = []
    }
  },
  computed: {
    isDisabled () {
      return false
    },
    placeholder () {
      return this.isDisabled ? '---' : 'Place'
    }
  },
  watch: {
    'textInput' () {
      if (this.textInput) {
        this.handleInput(this.textInput)
      } else {
        this.places = []
      }
    },
    'placeID' () {
      this.$emit('placeSelected', this.placeID || '')
    },
    'currentPlaceID' () {
      if (this.currentPlaceID) {
        this.setCurrentPlace()
      } else {
        this.clear()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .item-text {
    font-size: 13px;
  }

  .item-text-small {
    font-size: 11px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/PlaceSelector.vue